export default "__VITE_ASSET__CoGHKN2f__"